(() => {
  if (window.canvoilDeliveryJourneyLoaded) return;
  window.canvoilDeliveryJourneyLoaded = true;
  const addBusinessDays = (start, count) => {
    const date = new Date(start.getFullYear(), start.getMonth(), start.getDate(), 12);
    while (count > 0) {
      date.setDate(date.getDate() + 1);
      if (date.getDay() !== 0 && date.getDay() !== 6) count--;
    }
    return date;
  };
  const format = date => date.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
  const range = (today, min, max) => {
    const first = addBusinessDays(today, min);
    const last = addBusinessDays(today, max);
    if (first.getFullYear() !== last.getFullYear()) {
      return `${format(first)}, ${first.getFullYear()} – ${format(last)}, ${last.getFullYear()}`;
    }
    return first.getMonth() === last.getMonth()
      ? `${format(first)}–${last.getDate()}`
      : `${format(first)} – ${format(last)}`;
  };
  const render = () => {
    const today = new Date();
    document.querySelectorAll('.canvoil-delivery-journey').forEach(section => {
      section.querySelector('[data-journey-order]').textContent = format(today);
      section.querySelector('[data-journey-dispatch]').textContent = range(today, 5, 7);
      const days = section.dataset.deliveryRange.split('–').map(Number);
      if (days.length === 2 && days.every(n => Number.isInteger(n) && n > 0)) {
        section.querySelector('[data-journey-arrival]').textContent = range(today, days[0], days[1]);
      }
    });
  };
  render();
  document.addEventListener('shopify:section:load', render);
  window.addEventListener('pageshow', render);
  document.addEventListener('visibilitychange', () => { if (!document.hidden) render(); });
})();
